<template>
  <component
    :is="settingsCompId"
    v-if="enabled"
    :show.sync="enabled"
    :settings="settings"
    @update="updateSettings"
  />
</template>

<script>
import { getCompSettings } from "../templateHelper/Helper";
import ReceiptSummary from "./ReceiptSummary";
import KotSettings from "./KotSettings";

export default {
  name: "ComponentSettings",
  components: {
    ReceiptSummary,
    KotSettings
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      settingsCompId: null,
      key: null
    };
  },
  computed: {
    enabled: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      }
    },
    settings() {
      if (this.key && this.data && this.data.settings) {
        const settings = this.data.settings[this.key];
        if (settings) {
          return settings;
        }
      }
      return {};
    }
  },
  watch: {
    show: {
      handler(enabled) {
        if (enabled) {
          const { compId, key } = getCompSettings(this.data.componentType);
          this.settingsCompId = compId;
          this.key = key;
        }
      },
      immediate: true
    }
  },
  methods: {
    updateSettings(settings) {
      let settingsIns = {};
      settingsIns[this.key] = settings;
      this.$emit("updateSettings", {
        refId: this.data.refId,
        settingsIns
      });
    }
  }
};
</script>